import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function RequireAuth({ children }) {
  const { isAuth, authLoading } = useAuth();

  if (authLoading) return null;

  if (!isAuth) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
}